
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class Title extends Vue {
  @Prop({ default: '' }) name: string

  get isShow() {
    return ['course', 'account', 'study', 'calendar', 'experience', 'book'].includes(this.name)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
